export default "__VITE_ASSET__4c9c4193__"